import axios from 'axios';

const addDataToUrl = (url, sliCode, rank) =>
  url.replace('sliCode', sliCode).replace('rank', rank);

export const sendToSli = (styleCode, productListingState) => {
  const { clickLoggingUrl, items } = productListingState;
  const style = items.find(s => s.styleCode === styleCode);
  const rank = items.indexOf(style);

  // Don't await the response because don't need it.
  axios.get(addDataToUrl(clickLoggingUrl, style.sliCode, rank));
};

export default {
  sendToSli,
};
